import { render } from "./VCVerifiersIndexView.vue?vue&type=template&id=1dec1a3c"
import script from "./VCVerifiersIndexView.vue?vue&type=script&lang=js"
export * from "./VCVerifiersIndexView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__